module.exports = __webpack_public_path__ + "static/media/11_l_kust_9.48_82.13.69a2ebd6.png";